// ----------------------------------------------------------------------------
// Snippet: Announcement Bar
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_announcement-bar.scss';

// -------------------------------------
// Variables
// -------------------------------------

var STATIC_BAR_SELECTOR = '.announcement-bar--static';
var STATIC_BAR_HIDDEN_CLASS = 'announcement-bar--static-hidden';
var STICKY_BAR_SELECTOR = '.announcement-bar[data-announcement-bar-sticky="true"]';
var STICKY_HEIGHT_PROPERTY = '--sticky-announcement-height';

// -------------------------------------
// Helpers
// -------------------------------------

function syncStickyAnnouncementBarHeight() {
  var stickyBars = document.querySelectorAll(STICKY_BAR_SELECTOR);
  var stickyHeight = 0;
  Array.prototype.forEach.call(stickyBars, announcementBar => {
    if (announcementBar.classList.contains('announcement-bar--hidden')) {
      return;
    }
    var section = announcementBar.closest('.section--announcement-bar');
    stickyHeight += (section === null || section === void 0 ? void 0 : section.offsetHeight) || announcementBar.offsetHeight;
  });
  document.documentElement.style.setProperty(STICKY_HEIGHT_PROPERTY, "".concat(stickyHeight, "px"));
}
function updateStaticAnnouncementBar() {
  var scrollTop = document.documentElement.scrollTop || window.pageYOffset;
  var announcementBars = document.querySelectorAll(STATIC_BAR_SELECTOR);
  Array.prototype.forEach.call(announcementBars, announcementBar => {
    var announcementBarHeight = announcementBar.offsetHeight;
    announcementBar.classList.toggle(STATIC_BAR_HIDDEN_CLASS, scrollTop > announcementBarHeight);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  syncStickyAnnouncementBarHeight();
  updateStaticAnnouncementBar();
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(() => {
      syncStickyAnnouncementBarHeight();
    });
    document.querySelectorAll(STICKY_BAR_SELECTOR).forEach(bar => {
      resizeObserver.observe(bar);
    });
  }
});
window.addEventListener('scroll', updateStaticAnnouncementBar, {
  passive: true
});
window.addEventListener('resize', syncStickyAnnouncementBarHeight);